import { FeatureLabel3D } from 'features/assetViz/objects/features/procedural/FeatureLabel3D'
import {
  SurfaceLineFeature3D,
  SurfaceLineSelectionType,
} from 'features/assetViz/objects/features/procedural/SurfaceLineFeature3D'
import React from 'react'
import { GeckoComponentPath, GeckoPipeCircumferentialWeld } from 'types'

/**
 * A component used to render a single circumferential weld on a pipe section's surface
 * @param model             The asset model for this horizontal weld
 * @constructor
 */
export const PipeCircumferentialWeldFeature3D: React.FC<{
  model: GeckoPipeCircumferentialWeld
}> = ({ model }) => {
  const path = React.useMemo(() => {
    return GeckoComponentPath.CreateFromHorizontalLine(model.feature_geometry)
  }, [model.feature_geometry])

  return (
    <group name={model.id}>
      <SurfaceLineFeature3D
        path={path}
        featureModel={model}
        lineSelectionType={SurfaceLineSelectionType.SelectableFeatureLine}
      />
      <FeatureLabel3D
        feature={model}
        coords={model.feature_geometry.end}
        anchor={'center'}
      />
    </group>
  )
}
